import { CountingSchemes } from '@ahaslides-product/frontend-toolkit'
import Constant from '@/constant'
import EventBus from '@/eventBus'

const setTotalJoinedPresentationAction = ({ commit }, payload) => {
  commit('setTotalJoinedPresentation', payload)
}

const setTotalAnsweredSlideAction = ({ commit }, payload) => {
  commit('setTotalAnsweredSlide', payload)
}

const clearEveryoneAnsweredPresentationAction = ({ commit }) => {
  commit('clearEveryoneAnsweredPresentation')
}
const clearEveryoneAnsweredSlideAction = ({ commit }) => {
  commit('clearEveryoneAnsweredSlide')
}
const checkEveryoneHasAnsweredAction = async ({ state, rootGetters }, payload) => {
  const countJoined = state.totalJoinedPresentation[payload.presentationId]
  const countAnswered = state.totalAnsweredSlide[payload.slideId]
  const isQuizSlideType = state.slideActive.type === 'pickAnswer'
    || rootGetters['slidePlugin/isSlideActiveFullQuizPlugin']
  const isQuizRunning = isQuizSlideType && state.slideActive.quizStatus === Constant.QuizStatuses.QUESTION_SCREEN
  if (countJoined && countAnswered && countJoined === countAnswered &&
      isQuizRunning && countJoined >= state.userOnline) {
    EventBus.$emit('everyone-voted')
  }
}

const resetCountingEveryoneHasAnswered = async ({ dispatch, state, commit }) => {
  const countingPayload = {
    keys: [
      CountingSchemes.everyoneAnsweredJoined({
        presentationId: state.presentation.id,
        presentationVersion: state.presentation.version,
      }),
      CountingSchemes.everyoneAnsweredSlide({
        presentationId: state.presentation.id,
        slideId: state.slideActive.id,
        slideVersion: state.slideActive.version,
      }),
    ],
  }
  await dispatch('resetCounting', countingPayload)
  // The readers react to a changed total, so a restarted count that lands on the old value must not look unchanged.
  await dispatch('counting/forget', countingPayload)
  commit('clearEveryoneAnsweredPresentation')
  commit('clearEveryoneAnsweredSlide')
  return null
}

export default {
  setTotalJoinedPresentationAction,
  setTotalAnsweredSlideAction,
  checkEveryoneHasAnsweredAction,
  clearEveryoneAnsweredPresentationAction,
  clearEveryoneAnsweredSlideAction,
  resetCountingEveryoneHasAnswered,
}
